<template>
  <div class="xes-login-phone_code">
    <div class="xes-login-phone_code-text" @click="isVisible = !isVisible">
      <span>+{{ currentValue }}</span>
      <van-icon name="arrow-up" class="icon" v-if="isVisible"></van-icon>
      <van-icon name="arrow-down" class="icon" v-else></van-icon>
    </div>
    <ul class="xes-login-phone_code-list" v-if="isVisible">
      <li
        :class="['codeItem', { active: item.value === currentValue }]"
        v-for="(item, index) in options"
        :key="item.id"
        @click="selectPhoneCode(index)"
      >
        {{ item.text }} (+{{ item.value }})
      </li>
    </ul>
  </div>
</template>
<script>
import { Icon } from 'vant'
export default {
  name: 'select-phone-code',
  components: {
    'van-icon': Icon
  },
  props: {
    options: Array,
    value: {
      default: 86
    }
  },
  data() {
    return {
      currentValue: 86,
      isVisible: false
    }
  },
  methods: {
    selectPhoneCode(index) {
      this.currentValue = this.options[index].value
      this.$emit('input', this.currentValue)
      this.isVisible = false
    }
  }
}
</script>
<style lang="less" scoped>
.xes-login-phone_code {
  .xes-login-phone_code-text {
    width: 80px;
    cursor: pointer;
    padding-right: 10px;
    text-align: right;
    .icon {
      vertical-align: -2px;
      margin-left: 5px;
    }
  }
  .xes-login-phone_code-list {
    position: absolute;
    top: 48px;
    z-index: 2;
    background-color: white;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
    padding: 8px 0;
    border-radius: 8px;
    line-height: 44px;
    .active {
      background-color: #f9f9fc;
    }
    .codeItem {
      padding: 0 18px;
      cursor: pointer;
    }
  }
}
</style>
